import { render } from "./NoteInfo.vue?vue&type=template&id=f57ea90a&scoped=true"
import script from "./NoteInfo.vue?vue&type=script&lang=js"
export * from "./NoteInfo.vue?vue&type=script&lang=js"

import "./NoteInfo.vue?vue&type=style&index=0&id=f57ea90a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f57ea90a"]])

export default __exports__